import React from 'react';

const SalaryRateCategorySelect = ({ 
  value, 
  onChange, 
  rules = [], 
  loading = false, 
  isEditMode = false 
}) => {
  return (
    <>
      <select
        disabled={!isEditMode}
        value={value || ''}
        onChange={(e) => onChange(e.target.value ? Number(e.target.value) : null)}
        style={{ color: value ? "#686868" : "#aaa" }}
      >
        <option value="">-- Select Matching Rate --</option>
        {rules.map(rule => (
          <option key={rule.id} value={rule.id}>
            {rule.category} (Rate: {rule.salary})
          </option>
        ))}
      </select>

      {/* Warning logic encapsulated inside the input area */}
      {rules.length === 0 && !loading && (
        <span style={{ color: 'red', fontSize: '10px', display: 'block', marginTop: '4px' }}>
          ⚠️ No matching rates found for current criteria.
        </span>
      )}
    </>
  );
};

export default SalaryRateCategorySelect;